import i18n from 'i18n';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { showNotification } from 'components';
import { consumptionPlaceUploadService } from 'services';
import { NotificationType, QueryContextFromKeys, QueryParamModel } from 'models';
import { REACT_QUERY_OPTIONS } from 'config/reactQueryConfig';
import { isListEnabled } from 'utils/queryHelpers';

type ConsumptionPlaceUploadContexts = QueryContextFromKeys<typeof consumptionPlaceUploadKeys>;

export const consumptionPlaceUploadKeys = {
  all: [{ scope: 'consumptionPlaceUpload' }] as const,
  lists: () => [{ ...consumptionPlaceUploadKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) =>
    [{ ...consumptionPlaceUploadKeys.lists()[0], params }] as const,
};

const fetchList = async ({ queryKey: [{ params }] }: ConsumptionPlaceUploadContexts['list']) =>
  consumptionPlaceUploadService.getList(params);

export const useConsumptionPlaceUploadList = (params?: QueryParamModel | null) =>
  useQuery({
    queryKey: consumptionPlaceUploadKeys.list(params),
    queryFn: fetchList,
    enabled: isListEnabled(params),
  });

export const useUploadConsumptionPlaces = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (files: File[]) => consumptionPlaceUploadService.upload(files),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consumptionPlaceUploadKeys.lists() });
      showNotification({
        content: i18n.t('FOGYASZTASI_HELYEK_BETOLTESE.UPLOAD_SUCCESS'),
        type: NotificationType.SUCCESS,
      });
    },
  });
};

export const useDownloadConsumptionPlaceLog = () => {
  return useMutation({
    mutationFn: (id: number) => consumptionPlaceUploadService.downloadLog(id),
    meta: {
      [REACT_QUERY_OPTIONS.SKIP_DEFAULT_SUCCESS_CALLBACK]: true,
    },
  });
};
